import PaymentTypeAdd from "@/views/paymentType/PaymentTypeAdd";
import PaymentTypeList from "@/views/paymentType/PaymentTypeList";
import PaymentTypeEdit from "@/views/paymentType/PaymentTypeEdit";

const routes = [
 {
    path: '/PaymentType/add',
    name: 'PaymentTypeAdd',
    component: PaymentTypeAdd,
    meta:{requiredAuth:true}
  },{
    path: '/PaymentType/list',
    name: 'PaymentTypeList',
    component: PaymentTypeList,
    meta:{requiredAuth:true}
  },{
    path: '/PaymentType/Edit/:id',
    name: 'PaymentTypeEdit',
    component: PaymentTypeEdit,
    meta:{requiredAuth:true}
  },
]

export default routes